// tables
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { ToastService } from 'ng-uikit-pro-standard';
import { GeneralService } from 'src/app/services/general.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConfigService } from 'src/app/app-config.service.service';
import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { MapInformationService } from 'src/app/services/map-information.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomerService } from 'src/app/services/customer.service';
import { ProjectService } from 'src/app/services/project.service';
@Component({
  selector: 'app-create-update-activity-dinamic',
  templateUrl: './create-update-activity-dinamic.component.html',
  styleUrls: ['./create-update-activity-dinamic.component.scss']
})
export class CreateUpdateActivityDinamicComponent implements OnInit {

  _data:any
  items: any = [

    "undo", "redo", "separator",

    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },

    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",

    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },

    "color", "background", "link", "clear", "codeBlock", "blockquote", "separator", "insertTable", "deleteTable",
    "insertRowAbove", "insertRowBelow", "deleteRow", "insertColumnLeft", "insertColumnRight",
    "deleteColumn", "cellProperties", "tableProperties",
  ];

  @Input() from: any;
  @Input() from2: any;
  @Input() parentId: any;

  optionsProjects: any = [];

  // Assign project to site
  showAssignProjectPopup: boolean = false;
  allProjects: any[] = [];
  filteredProjects: any[] = [];
  projectSearchValue: string = '';

  @Input('data')
  set data(data: any) {
    if (data != undefined){
      console.log('Data from parent ', data);
      this._data = data;
      console.log(this._data)
      this.ngOnInit();
    }
  }


  @Output() onsubmit = new EventEmitter<any>();

  //InputsFecha
  today = new Date().getTime();
  millisecondsInDay = 24 * 60 * 60 * 1000;
  followupdate: any = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };
  startDate: any = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };

  employeeid: any;

  //Formulario
  actitivityForm: FormGroup;
  optionsempleoyees: any = [];
  optionsactivityType: any = [];

  editLinkButton: any;
  externalLink: any = '';
  hideIconLink: boolean = true;

  userId: any;
  settings: any;
  employeename: any;

  constructor(
    private datepipe: DatePipe,
    private toast: ToastService,
    private appconfig: AppConfigService,
    public generalService: GeneralService,
    private MapInformationService: MapInformationService,
    private translate:TranslateService,
    private customerService: CustomerService,
    private projectService: ProjectService,
  ) {
    console.log('ESTOY EN MY CALENDAR ');

    this.userId = localStorage.getItem('customerid');

    this.settings = this.appconfig.dateFormat;

    this.editLinkButton = {
      icon: 'fa fa-link',
      type: 'default',
      onClick: () => {
        window.open(this.externalLink, "_blank");
      },
    }
  }

  ngOnInit() {
    console.log('Data ', this._data);
    console.log(this.from)
    if(this._data){
      // this.employeeid = this.userId;
      // this.employeename = this._data.EMPLOYEENAME;
      // this.optionsempleoyees = [{ key: this.employeeid, Name: this.employeename }]
      // console.log(this.employeename, ' / ', this.optionsempleoyees);
      this.setFormActivities(this._data)
      this.getActivities()
    }else{
      this.initForm();
      this.getActivities()
    }
    this.getSelectsData();
  }

  initForm(){

    this.inputsDate(this.followupdate, this.today)
    this.inputsDate(this.startDate, this.today)

    this.actitivityForm = new FormGroup({
      id: new FormControl({ value: 0, disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, []),
      Employee: new FormControl({ value: this.employeeid, disabled: false }, []),
      EndTime: new FormControl({ value: this.followupdate.showDate, disabled: false }, []),
      ActivityType: new FormControl({ value: '', disabled: false }, []),
      StartTime: new FormControl({ value: this.startDate.showDate, disabled: false }, []),
      FollowUp: new FormControl({ value: '', disabled: false }, []),
      Closed: new FormControl({ value: false, disabled: false }, []),
      externallink: new FormControl({ value: false, disabled: false }, []),
      Description: new FormControl({ value: '', disabled: false }, []),
      FollowUpComments: new FormControl({ value: '', disabled: false }, []),
      Hour: new FormControl({ value: this.today, disabled: false }, []),
      Minute: new FormControl({ value: '00:01', disabled: false }, [Validators.required]),
      OptCustomer: new FormControl({ value: 0, disabled: false }, [Validators.maxLength(45)]),
      OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
      OptProject: new FormControl({ value: 0, disabled: false }, []),
      ProjectId: new FormControl({ value: 0, disabled: false }, []),
      sort: new FormControl({ value: 0, disabled: false }, []),
    });
    this.follow = ""
    this.descr = ""
  }

  setFormActivities(data){
    console.log(data); 

    if (this.from == "EditSalesLead"){

      this.inputsDate(this.followupdate, data.EndTime)
      this.inputsDate(this.startDate, data.StartDateTime)
  
      data.FOLLOWUP = data.FOLLOWUP == 'No' || data.FOLLOWUP == false ? false : true;
      data.CLOSED = data.CLOSED == 'No' || data.CLOSED == false ? false : true;
  
      let duration;
        let dutationSub1 = data.DURATION + '';
        if (data.DURATION % 1 == 0) {
          //alert ("Es un numero entero");
          duration = data.DURATION + ':00'
          if (duration.length < 5) {
            duration = '0' + duration;
          }
        } else {
          if (dutationSub1.length < 5) {
            if (data.DURATION < 10) {
              if (data.DURATION < 1) {
                if (dutationSub1.length > 3) {
                  duration = 0 + dutationSub1.replace('.', ":");
                } else {
                  duration = 0 + dutationSub1.replace('.', ":") + 0;
                }
              } else {
                duration = 0 + dutationSub1.replace('.', ":");
                if (duration.length < 5) {
                  duration = duration + '0';
                }
              }
            } else {
              duration = dutationSub1.replace('.', ":");
              duration = duration + '0';
            }
          } else {
            duration = dutationSub1.replace('.', ":");
          }
        }
  
      this.actitivityForm = new FormGroup({
        id: new FormControl({ value: data.ID, disabled: false }, []),
        activityid: new FormControl({ value: data.ID, disabled: false }, []),
        Name: new FormControl({ value: data.NAME, disabled: false }, []),
        Employee: new FormControl({ value: data.EmployeeId, disabled: false }, []),
        sort: new FormControl({ value: data.SORT, disabled: false }, []),
        ActivityType: new FormControl({ value: data.TypeId, disabled: false }, []),

        EndTime: new FormControl({ value: this.followupdate.showDate, disabled: false }, []),
        StartTime: new FormControl({ value: this.startDate.showDate, disabled: false }, []),

        FollowUp: new FormControl({ value: data.FOLLOWUP, disabled: false }, []),
        Closed: new FormControl({ value: data.CLOSED, disabled: false }, []),
        externallink: new FormControl({ value: data.EXTERNALLINK, disabled: false }, []),
        Description: new FormControl({ value: data.NOTES, disabled: false }, []),
        FollowUpComments: new FormControl({ value: data.FOLLOWUPCOMMENTS, disabled: false }, []),

        Hour: new FormControl({ value: 0, disabled: false }, []),
        Minute: new FormControl({ value: duration, disabled: false }, [Validators.required]),
        OptCustomer: new FormControl({ value: 0, disabled: false }, [Validators.maxLength(45)]),
        OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
        OptProject: new FormControl({ value: 0, disabled: false }, []),
        ProjectId: new FormControl({ value: data.PROJECTID || 0, disabled: false }, []),
        Customer: new FormControl({ value: -1, disabled: false }, []),
        Project: new FormControl({ value: -1, disabled: false }, []),
        ServiceSite: new FormControl({ value: -1, disabled: false }, []),
      });

      this.follow = data.FOLLOWUPCOMMENTS
      this.descr = data.NOTES



    } else if (this.from == "EditCustomer"){

      this.inputsDate(this.followupdate, data.FOLLOWUPDATE)
      this.inputsDate(this.startDate, data.STARTTIME)
  
      data.FOLLOWUP = data.FOLLOWUP == 'No' || data.FOLLOWUP == false ? false : true;
      data.CLOSED = data.CLOSED == 'No' || data.CLOSED == false ? false : true;
  
      let duration;
        let dutationSub1 = data.DURATION + '';
        if (data.DURATION % 1 == 0) {
          //alert ("Es un numero entero");
          duration = data.DURATION + ':00'
          if (duration.length < 5) {
            duration = '0' + duration;
          }
        } else {
          if (dutationSub1.length < 5) {
            if (data.DURATION < 10) {
              if (data.DURATION < 1) {
                if (dutationSub1.length > 3) {
                  duration = 0 + dutationSub1.replace('.', ":");
                } else {
                  duration = 0 + dutationSub1.replace('.', ":") + 0;
                }
              } else {
                duration = 0 + dutationSub1.replace('.', ":");
                if (duration.length < 5) {
                  duration = duration + '0';
                }
              }
            } else {
              duration = dutationSub1.replace('.', ":");
              duration = duration + '0';
            }
          } else {
            duration = dutationSub1.replace('.', ":");
          }
        }
  
      this.actitivityForm = new FormGroup({
        id: new FormControl({ value: data.ID, disabled: false }, []),
        activityid: new FormControl({ value: data.ID, disabled: false }, []),
        Name: new FormControl({ value: data.NAME, disabled: false }, []),
        Employee: new FormControl({ value: data.EMPLOYEEID, disabled: false }, []),
        sort: new FormControl({ value: data.SORT, disabled: false }, []),
        ActivityType: new FormControl({ value: data.TYPE, disabled: false }, []),

        EndTime: new FormControl({ value: this.followupdate.showDate, disabled: false }, []),
        StartTime: new FormControl({ value: this.startDate.showDate, disabled: false }, []),

        FollowUp: new FormControl({ value: data.FOLLOWUP, disabled: false }, []),
        Closed: new FormControl({ value: data.CLOSED, disabled: false }, []),
        externallink: new FormControl({ value: data.EXTERNALLINK, disabled: false }, []),
        Description: new FormControl({ value: data.NOTES, disabled: false }, []),
        FollowUpComments: new FormControl({ value: data.FOLLOWUPCOMMENTSsinHTML, disabled: false }, []),

        Hour: new FormControl({ value: 0, disabled: false }, []),
        Minute: new FormControl({ value: duration, disabled: false }, [Validators.required]),
        OptCustomer: new FormControl({ value: 0, disabled: false }, [Validators.maxLength(45)]),
        OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
        OptProject: new FormControl({ value: 0, disabled: false }, []),
        ProjectId: new FormControl({ value: data.PROJECTID || 0, disabled: false }, []),
        Customer: new FormControl({ value: -1, disabled: false }, []),
        Project: new FormControl({ value: -1, disabled: false }, []),
        ServiceSite: new FormControl({ value: -1, disabled: false }, []),
      });

      this.follow = data.FOLLOWUPCOMMENTSsinHTML
      this.descr = data.NOTES



    } else if (this.from == "EditSalesProject"){

      this.inputsDate(this.followupdate, data.EndTime)
      this.inputsDate(this.startDate, data.StartDateTime)
  
      data.FOLLOWUP = data.FOLLOWUP == 'No' || data.FOLLOWUP == false ? false : true;
      data.CLOSED = data.CLOSED == 'No' || data.CLOSED == false ? false : true;
  
      let duration;
        let dutationSub1 = data.DURATION + '';
        if (data.DURATION % 1 == 0) {
          //alert ("Es un numero entero");
          duration = data.DURATION + ':00'
          if (duration.length < 5) {
            duration = '0' + duration;
          }
        } else {
          if (dutationSub1.length < 5) {
            if (data.DURATION < 10) {
              if (data.DURATION < 1) {
                if (dutationSub1.length > 3) {
                  duration = 0 + dutationSub1.replace('.', ":");
                } else {
                  duration = 0 + dutationSub1.replace('.', ":") + 0;
                }
              } else {
                duration = 0 + dutationSub1.replace('.', ":");
                if (duration.length < 5) {
                  duration = duration + '0';
                }
              }
            } else {
              duration = dutationSub1.replace('.', ":");
              duration = duration + '0';
            }
          } else {
            duration = dutationSub1.replace('.', ":");
          }
        }
  
      this.actitivityForm = new FormGroup({
        id: new FormControl({ value: data.ID, disabled: false }, []),
        activityid: new FormControl({ value: data.ID, disabled: false }, []),
        Name: new FormControl({ value: data.NAME, disabled: false }, []),
        Employee: new FormControl({ value: data.EmployeeId, disabled: false }, []),
        sort: new FormControl({ value: data.SORT, disabled: false }, []),
        ActivityType: new FormControl({ value: data.TypeId, disabled: false }, []),

        EndTime: new FormControl({ value: this.followupdate.showDate, disabled: false }, []),
        StartTime: new FormControl({ value: this.startDate.showDate, disabled: false }, []),

        FollowUp: new FormControl({ value: data.FOLLOWUP, disabled: false }, []),
        Closed: new FormControl({ value: data.CLOSED, disabled: false }, []),
        externallink: new FormControl({ value: data.EXTERNALLINK, disabled: false }, []),
        Description: new FormControl({ value: data.NOTES, disabled: false }, []),
        FollowUpComments: new FormControl({ value: data.FOLLOWUPCOMMENTSsinHTML, disabled: false }, []),

        Hour: new FormControl({ value: 0, disabled: false }, []),
        Minute: new FormControl({ value: duration, disabled: false }, [Validators.required]),
        OptCustomer: new FormControl({ value: 0, disabled: false }, [Validators.maxLength(45)]),
        OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
        OptProject: new FormControl({ value: 0, disabled: false }, []),
        ProjectId: new FormControl({ value: data.PROJECTID || 0, disabled: false }, []),
        Customer: new FormControl({ value: -1, disabled: false }, []),
        Project: new FormControl({ value: -1, disabled: false }, []),
        ServiceSite: new FormControl({ value: -1, disabled: false }, []),
      });

      this.follow = data.FOLLOWUPCOMMENTSsinHTML
      this.descr = data.NOTES


    }else {
      this.inputsDate(this.followupdate, data.EndTime)
      this.inputsDate(this.startDate, data.STARTTIME)
  
      data.FOLLOWUP = data.FOLLOWUP == 'No' ? false : true;
      data.CLOSED = data.CLOSED == 'No' || data.CLOSED == false ? false : true;
  
      let duration;
        let dutationSub1 = data.DURATION + '';
        if (data.DURATION % 1 == 0) {
          //alert ("Es un numero entero");
          duration = data.DURATION + ':00'
          if (duration.length < 5) {
            duration = '0' + duration;
          }
        } else {
          //alert ("Es un numero decimal");
          if (dutationSub1.length < 5) {
            if (data.DURATION < 10) {
              if (data.DURATION < 1) {
                if (dutationSub1.length > 3) {
                  duration = 0 + dutationSub1.replace('.', ":");
                } else {
                  duration = 0 + dutationSub1.replace('.', ":") + 0;
                }
              } else {
                duration = 0 + dutationSub1.replace('.', ":");
                if (duration.length < 5) {
                  duration = duration + '0';
                }
              }
            } else {
              duration = dutationSub1.replace('.', ":");
              duration = duration + '0';
            }
          } else {
            duration = dutationSub1.replace('.', ":");
          }
        }
  
      this.actitivityForm = new FormGroup({
        id: new FormControl({ value: data.ID, disabled: false }, []),
        activityid: new FormControl({ value: data.ID, disabled: false }, []),
        Name: new FormControl({ value: data.NAME, disabled: false }, []),
        Employee: new FormControl({ value: this.employeeid, disabled: false }, []),
        sort: new FormControl({ value: data.sort, disabled: false }, []),
        EndTime: new FormControl({ value: this.followupdate.showDate, disabled: false }, []),
        ActivityType: new FormControl({ value: data.TYPEID, disabled: false }, []),
        StartTime: new FormControl({ value: this.startDate.showDate, disabled: false }, []),
        FollowUp: new FormControl({ value: data.FOLLOWUP, disabled: false }, []),
        Closed: new FormControl({ value: data.CLOSED, disabled: false }, []),
        externallink: new FormControl({ value: data.EXTERNALLINK, disabled: false }, []),
        Description: new FormControl({ value: data.NOTES, disabled: false }, []),
        FollowUpComments: new FormControl({ value: data.FOLLOWUPCOMMENTS, disabled: false }, []),
        Hour: new FormControl({ value: 0, disabled: false }, []),
        Minute: new FormControl({ value: duration, disabled: false }, [Validators.required]),
        OptCustomer: new FormControl({ value: 0, disabled: false }, [Validators.maxLength(45)]),
        OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
        OptProject: new FormControl({ value: 0, disabled: false }, []),
        Customer: new FormControl({ value: -1, disabled: false }, []),
        Project: new FormControl({ value: -1, disabled: false }, []),
        ServiceSite: new FormControl({ value: -1, disabled: false }, []),
      });
  
      this.follow = data.FOLLOWUPCOMMENTS
      this.descr = data.NOTES
    }


  }

  getSelectsData(){
    if(this.optionsactivityType.length == 0){
      this.generalService.getPopulateGeneral('Customer/GetCustomerActivityType').subscribe(result => {
        this.optionsactivityType = result.map((val) => {
          return {  Name: val.Name, key: val.ID };
        });
      });
    }
    if(this.from2 == 'editservice' && this.parentId){
      this.MapInformationService.SaveInfoSites({ method: 'Get_ProjectsBySite', siteid: this.parentId }).subscribe(result => {
        this.optionsProjects = result;
        if (result.length === 1 && this.actitivityForm && !this.actitivityForm.get('ProjectId').value) {
          this.actitivityForm.get('ProjectId').setValue(result[0].PROJECTID);
        }
      });
    }
  }

  enableIconLink(e){
    console.log(e);

    if(e.length > 0){
      this.hideIconLink = false;
    }else{
      this.hideIconLink = true;
    }
  }

  saveActivity(id, from){

    if (this.actitivityForm.value.ActivityType == "" || this.actitivityForm.value.ActivityType == null || this.actitivityForm.value.ActivityType == undefined){ 
      this.toast.warning("You must select an activity type");
      return false 
    } 

    if (from == "EditSalesLead"){

      let form = this.actitivityForm.value
      const idSalesLead = id
      let hour, minute;

      form.Minute = form.Minute.replace(':', "");
      hour = parseInt(form.Minute.substr(0, 2));
      minute = parseInt(form.Minute.substr(2, 2));
      // 13.30


    const dataFinal = {
      "id":form.id,
      "customerid": this.from2 == 'editcustomer' ? idSalesLead : 0,
      "servicesiteid": this.from2 == 'editservice' ? idSalesLead : null,
      "employeeid":form.Employee,
      "type":form.ActivityType,
      "notes":form.Description,
      "starttime":moment(form.StartTime).format('YYYY-MM-DD HH:mm'),
      "endtime":moment(form.EndTime).format('YYYY-MM-DD HH:mm'),
      "followup":form.FollowUp == true ? 1 : 0,
      "followupdate":moment(new Date()).format('YYYY-MM-DD HH:mm'),
      "name":form.Name,
      "closed":form.Closed == true ? 1 : 0,
      "followupcomments":form.FollowUpComments,
      "projectid": this.from2 == 'editservice' ? (form.ProjectId || 0) : (this.from2 != 'editcustomer' ? idSalesLead : 0),
      "duration":hour + "." + minute,
      "externallink":form.externallink,
      "sort":form.sort,
      "method":"InsertUpdateActivity",
    }

    if(this.from2 == 'editcustomer'){
      dataFinal.customerid = idSalesLead
      delete dataFinal.projectid
    }

    this.MapInformationService.SaveInfoSites(dataFinal).subscribe(
      data => {
        console.log('Guardado en COmponent ', data);

        if (form.id > 0) {
          this.toast.success(this.translate.instant('msgActEdiSucc'));
        } else {
          this.toast.success(this.translate.instant('msgActCreSucc'));
          this.initForm();
        }
        this.onsubmit.emit();

      }, err => {
        console.log(err)
      }
    )

    } else if (from == "EditCustomer"){
      
      let form = this.actitivityForm.value
      const idCustomer = id
      let hour, minute;

      form.Minute = form.Minute.replace(':', "");
      hour = parseInt(form.Minute.substr(0, 2));
      minute = parseInt(form.Minute.substr(2, 2));


      console.log(form)


  const dataFinal = {
    "id":form.id,
    "customerid":idCustomer,
    "servicesiteid":null,
    "employeeid":form.Employee,
    "type":form.ActivityType,
    "notes":form.Description,
    "starttime":moment(form.StartTime).format('YYYY-MM-DD HH:mm'),
    "endtime":moment(form.EndTime).format('YYYY-MM-DD HH:mm'),
    "followup":form.FollowUp == true ? 1 : 0,
    "followupdate":moment(new Date()).format('YYYY-MM-DD HH:mm'),
    "name":form.Name,
    "closed":form.Closed == true ? 1 : 0,
    "followupcomments":form.FollowUpComments,
    // "projectid":null,
    "duration":hour + "." + minute,
    "externallink":form.externallink,
    "sort":form.sort,
    "method":"InsertUpdateActivity",
    "OptCustomer": 1,
    "OptProject": 0,
    "OptServiceSite":0 
  }

  console.log(dataFinal)

    this.MapInformationService.SaveInfoSites(dataFinal).subscribe(
      data => {
        console.log('Guardado en COmponent ', data);

        if (form.id > 0) {
          this.toast.success(this.translate.instant('msgActEdiSucc'));
        } else {
          this.toast.success(this.translate.instant('msgActCreSucc'));
          this.initForm();
        }
        this.onsubmit.emit();

      }, err => {
        console.log(err)
      }
    )

    } else if (from == "EditSalesProject"){

      let form = this.actitivityForm.value
      const idSalesProject = id
      let hour, minute;

      form.Minute = form.Minute.replace(':', "");
      hour = parseInt(form.Minute.substr(0, 2));
      minute = parseInt(form.Minute.substr(2, 2));
      // 13.30


    const dataFinal = {
      "id":form.id,
      "customerid":0,
      "servicesiteid":null,
      "employeeid":form.Employee,
      "type":form.ActivityType,
      "notes":form.Description,
      "starttime":moment(form.StartTime).format('YYYY-MM-DD HH:mm'),
      "endtime":moment(form.EndTime).format('YYYY-MM-DD HH:mm'),
      "followup":form.FollowUp == true ? 1 : 0,
      "followupdate":moment(new Date()).format('YYYY-MM-DD HH:mm'),
      "name":form.Name,
      "closed":form.Closed == true ? 1 : 0,
      "followupcomments":form.FollowUpComments,
      "projectid":idSalesProject,
      "duration":hour + "." + minute,
      "externallink":form.externallink,
      "sort":form.sort,
      "method":"InsertUpdateActivity",
      "OptCustomer": 0,
      "OptProject": 1,
      "OptServiceSite":0 
    }

    this.MapInformationService.SaveInfoSites(dataFinal).subscribe(
      data => {
        console.log('Guardado en COmponent ', data);

        if (form.id > 0) {
          this.toast.success(this.translate.instant('msgActEdiSucc'));
        } else {
          this.toast.success(this.translate.instant('msgActCreSucc'));
          this.initForm();
        }
        this.onsubmit.emit();

      }, err => {
        console.log(err)
      }
    )



    } else {
      let form = this.actitivityForm.value
      let hour, minute;

      if (form.name === "")  "New Activity" ;
      form.FollowUp = form.FollowUp == true ? 1 : 0;
      form.Closed = form.Closed == true ? 1 : 0;
      form.method = form.id == 0 ?  'SaveActivity' : 'UpdateActivity';
      form.StartTime = moment(form.StartTime).format('YYYY-MM-DD HH:mm');
      form.EndTime = moment(form.EndTime).format('YYYY-MM-DD HH:mm');
      form.Minute = form.Minute.replace(':', "");
      hour = parseInt(form.Minute.substr(0, 2));
      minute = parseInt(form.Minute.substr(2, 2));
      form.Minute = minute;
      form.Hour = hour;
      form.Employee = this.employeeid;

      console.log('New Form ', form);

      this.MapInformationService.SaveInfoSites(form).subscribe(
        data => {
          console.log('Guardado en COmponent ', data);

          if (form.id > 0) {
            this.toast.success(this.translate.instant('msgActEdiSucc'));
          } else {
            this.toast.success(this.translate.instant('msgActCreSucc'));
            this.initForm();
          }
          this.onsubmit.emit();

        }, err => {
          console.log(err)
        }
      )
    }

  }

  now: Date = new Date();
  inputsDate(date, showdate) {
    if (showdate !== null) {
      let year = this.datepipe.transform(showdate, 'yyyy');
      date.showDate = parseInt(year) < 1990 ? new Date().getTime() : new Date(showdate).getTime();
    } else {
      date.showDate = new Date().getTime();
    }

    console.log(new Date (date.showDate))

    date.todayButton = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        date.showDate = new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate = date.showDate == null ? new Date().getTime() - this.millisecondsInDay : date.showDate - this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate = date.showDate == null ? new Date().getTime() + this.millisecondsInDay : date.showDate + this.millisecondsInDay;
      }
    };
  }

  openFullScreenDesc:boolean = false
  openFullScreenFollow:boolean = false
  descr:any= ""
  follow:any= ""
  openInputFullDesc(){
    this.openFullScreenDesc = true
  }

  asignarValue(event) {
    this.descr = event.value
    this.actitivityForm.get("Description").setValue(event.value)
  }

  openInputFullFollow(){
    this.openFullScreenFollow = true
  }

  asignarValueFllow(event){
    this.follow = event.value
    this.actitivityForm.get("FollowUpComments").setValue(event.value)
  }

  getActivities(){
    this.customerService.GetCustomerActivityEmployees().subscribe(
      data => {
        this.optionsempleoyees = data.map((val) => {
          return {
            Name: val.value,
            key: val.ID
          };
        });
        console.log(this.optionsempleoyees)
      })
  }

  openAssignProjectPopup() {
    this.projectSearchValue = '';
    if (this.allProjects.length === 0) {
      this.projectService.Get_All_ProjectsByName('').subscribe(result => {
        this.allProjects = result;
        this.filteredProjects = result;
      });
    } else {
      this.filteredProjects = this.allProjects;
    }
    this.showAssignProjectPopup = true;
  }

  onProjectSearch(e: any) {
    const val = (e.value || '').toLowerCase().trim();
    if (!val) {
      this.filteredProjects = this.allProjects;
      return;
    }
    this.filteredProjects = this.allProjects.filter(p => {
      const name = (p.NAME || p.Project_Name || '').toLowerCase();
      const id = (p.ID + '').toLowerCase();
      return name.includes(val) || id.includes(val);
    });
  }

  assignProjectToSite(project: any) {
    this.MapInformationService.SaveInfoSites({
      method: 'SetProjectSite',
      projecteid: project.ID,
      siteid: this.parentId,
    }).subscribe(() => {
      this.toast.success('Project linked to site successfully');
      this.showAssignProjectPopup = false;
      this.MapInformationService.SaveInfoSites({ method: 'Get_ProjectsBySite', siteid: this.parentId }).subscribe(result => {
        this.optionsProjects = result;
        const assigned = result.find(p => p.PROJECTID === project.ID);
        const projectId = assigned ? assigned.PROJECTID : (result.length > 0 ? result[0].PROJECTID : null);
        if (projectId) {
          this.actitivityForm.get('ProjectId').setValue(projectId);
        }
      });
    }, () => {
      this.toast.error('Error linking project to site');
    });
  }
}
